import SuccessPage from "./shared/SuccessPage";

export default function EmailPreferenceResetConfirmation() {
  return (
    <SuccessPage title="You're unsubscribed">
      Your email preferences have been updated. Account and order updates will
      continue as usual.
    </SuccessPage>
  );
}
